let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("DSq8B")).then(() => parcelRequire('lCM2t'));